export const MAX_HOLIDAY_DAYS = 25; // Maximum annual holiday allowance

export const TEAM_MEMBERS = [
  "Scott Blakebrough",
  "Aaron Snell",
  "Chris Brown",
  "John Taylor",
  "Ian Gourlay"
];

export const EMAIL_RECIPIENT = "chris.brown@dhsb.org";

export const firebaseConfig = {
  apiKey: "AIzaSyCssyngWkXQPZLol_XZYJcn5c7grxTbKG0",
  authDomain: "dhsb-holiday.firebaseapp.com",
  projectId: "dhsb-abfd1",
  storageBucket: "dhsb-abfd1.firebasestorage.app",
  messagingSenderId: "479980693174",
  appId: "1:479980693174:web:8952d66d8caa90846c2817"
};

